module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12EAMoX/tc-custom/9781626813366.jpg?1701061060939",
      "alt": "This image is the cover for the book Rapture's Slave"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rapture's Slave\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An emperor’s concubine and a courageous gladiator succumb to forbidden passion in a historical romance from the author of "), _c('i', [_vm._v("Captive of Desire")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When the virile young Nero first spots the exquisite Acte, illegitimate daughter of Emperor Claudius and a royal household slave, he knows he must have her. But even as Acte finds her deepest desires awakened by the magnificent Nero, she fears his sadistic nature."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Though she has been fated to serve as Nero’s carnal playmate when he becomes emperor of Rome, Acte finds the true love she dreams of in Sergio, a handsome gladiator. But in a loveless world where lust and power rule side by side, her secret obsession with Sergio might cost Acte her heart—and both of their lives."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “One of the finest and most gifted writers. A master storyteller!” —"), _c('i', [_vm._v("Romantic Times")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Becky Lee Weyrich\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0